module.exports = __webpack_public_path__ + "img/组 499@2x.12664716.png";